import { Configuration } from "config/config";
import { Component, OnInit } from "@angular/core";
import { IRequest } from "app/shared/Domains/request";
import { ActivatedRoute, Router } from "@angular/router";
import {
    SelectItem,
    ConfirmationService,
    MessageService,
} from "primeng/api";
import { BreadcrumbService } from "app/breadcrumb.service";
import { AppServiceManager } from "common/services/appServiceManager";
import { IMemberFreezeDetail } from "app/shared/Domains/memberFreezeDetail";
import { IMember } from "app/shared/Domains/member";
import { ICompany } from "app/shared/Domains/company";
import { IMemberContact } from "app/shared/Domains/memberContact";
import { ISettings } from "app/shared/Domains/settings";
import { IMemberEmergencyContact } from "app/shared/Domains/memberEmergencyContact";
import { IAddress } from "app/shared/Domains/address";
import { Customerstrainer } from "app/shared/Domains/Customerstrainer";
import { MemberService } from "common/services/member.service";

@Component({
    selector: "app-request-detail",
    templateUrl: "./request-detail.component.html",
    styleUrls: ["./request-detail.component.css"],
})
export class RequestDetailComponent implements OnInit {
    loading: boolean;
    mode: string;
    requestId: string;
    requestor: IRequest[] = [];
    freezeDetail: IMemberFreezeDetail;
    member: IMember;
    company: ICompany;
    daysLeft: any = "";
    tagNumber: any = "";
    freezeMemberDetails: any[];
    constructor(
        private route: ActivatedRoute,
        public config: Configuration,
        private confirmationServices: ConfirmationService,
        private router: Router,
        private messageService: MessageService,
        private breadcrumbService: BreadcrumbService,
        private appServiceManager: AppServiceManager,
       
    ) {
        route.params.subscribe((params) => {
            this.requestId = params["id"];
            if (this.requestId !== undefined) {
                this.requestId = params["id"];
                this.getRequestByID();
                // this.getFreezeReport();
            }
        });
    }

    ngOnInit() {
        this.InitObjects();
        if (this.requestId !== null && this.requestId !== undefined) {
            this.mode = "edit";
            this.breadcrumbService.setItems([
                { label: "Requests Management" },
                {
                    label: "All Request",

                    routerLink: "/requests-management/" + this.requestId,
                },
                { label: "Request" },
            ]);
        }
    }

    InitObjects() {
        this.requestor[0] = new IRequest();
        this.member = new IMember();
        this.company = new ICompany();
        this.freezeDetail = new IMemberFreezeDetail();
        // this.getFreezeReport();
        this.member.emergencyContact = new IMemberEmergencyContact();
        this.member.emergencyContact.medicalDetail = "";
        this.member.contactDetail = new IMemberContact();
        this.member.contactDetail.contact = "";
        this.requestor[0].contactDetail = new IMemberContact();
        this.member.contactDetail.address = new IAddress();
        this.requestor[0].contactDetail.address = new IAddress();
        this.member.customerstrainer = new Customerstrainer();
        this.member.settings = new ISettings();
    }

    getRequestByID() {
        this.loading = true;
        this.appServiceManager
            .get("customers/requests/" + this.requestId)
            .subscribe(
                (requestor) => {
                    this.requestor = [requestor];
                    this.loading = false;
                },
                (error) => {
                    this.loading = false;
                }
            );
    }

    

    setMemberData(member: IMember) {
        let date = new Date();
        member.settings = new ISettings();
        if (this.company.globalSetting && this.company.globalSetting.dueDate) {
            member.settings.dueDate = this.company.globalSetting.dueDate;
        } else {
            member.settings.dueDate = new Date();
        }
        this.freezeDetail.daysLeft = 0;
        this.freezeDetail.freezeDate = "";
        this.freezeDetail.isFreeze = false;
        member.freezeDetail = this.freezeDetail;
    }



    getFreezeReport() {
        this.freezeMemberDetails = [];
        this.appServiceManager
            .get("customers/freezeMemberDetails/" + this.requestor[0].tagNumber)
            .subscribe(
                (res: any) => {
                    if (res) {
                        this.freezeMemberDetails = res;
                    } else {
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "info",
                            summary: "Info Message",
                            detail: "Something Went Wrong",
                        });
                    }
                },
                (error) => {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: error,
                    });
                }
            );
    }

    validateMember(res) {
        if (
            this.member.settings === null ||
            this.member.settings === undefined
        ) {
            this.member.settings = new ISettings();
            this.member.settings.dueDate = null;
        } else if (
            this.member.settings.dueDate === null ||
            this.member.settings.dueDate === undefined
        ) {
            this.member.settings = new ISettings();
            this.member.settings.dueDate = null;
        } else if (res.settings.dueDate === "null") {
            this.member.settings.dueDate = null;
        } else {
            var dueDate = JSON.stringify(res.settings.dueDate);
            var DD = JSON.parse(dueDate).split("/");
            if (DD.length === 1) {
                this.member.settings.dueDate = new Date(DD);
            } else {
                var newDDate = DD[1] + "/" + DD[0] + "/" + DD[2];
                if (newDDate) {
                    this.member.settings.dueDate = new Date(newDDate);
                }
            }
        }
        if (
            this.member.customerstrainer === undefined ||
            this.member.customerstrainer === null
        ) {
            this.member.customerstrainer = new Customerstrainer();
            this.member.customerstrainer.name = "";
            this.member.customerstrainer.trainerId = "";
            this.member.customerstrainer.totalFees = "";
        }
        if (
            this.member.emergencyContact === null ||
            this.member.emergencyContact === undefined
        ) {
            this.member.emergencyContact = new IMemberEmergencyContact();
        } else if (
            this.member.emergencyContact.medicalDetail === null ||
            this.member.emergencyContact.medicalDetail === undefined
        ) {
            this.member.emergencyContact = new IMemberEmergencyContact();
        }
        if (this.member.contactDetail.address) {
            if (
                this.member.contactDetail.address.street === null &&
                this.member.contactDetail.address.street === ""
            ) {
                this.member.contactDetail.address.street = "";
            }
            if (
                this.member.contactDetail.address.city === null &&
                this.member.contactDetail.address.city === ""
            ) {
                this.member.contactDetail.address.city = "";
            }
            if (
                this.member.contactDetail.address.country === null &&
                this.member.contactDetail.address.country === ""
            ) {
                this.member.contactDetail.address.country = "";
            }
            if (
                this.member.contactDetail.address.state === null &&
                this.member.contactDetail.address.state === ""
            ) {
                this.member.contactDetail.address.state = "";
            }
            if (
                this.member.contactDetail.address.zipCode === null &&
                this.member.contactDetail.address.zipCode === ""
            ) {
                this.member.contactDetail.address.zipCode = "";
            }
            if (
                this.member.contactDetail.address.town === null &&
                this.member.contactDetail.address.town === ""
            ) {
                this.member.contactDetail.address.town = "";
            }
        } else {
            this.member.contactDetail.address = new IAddress();
        }
    }

    reject() {
        this.member = Object.assign(this.member, this.requestor);
        this.member.joiningDate = new Date();
        this.setMemberData(this.member);
        this.confirmationServices.confirm({
            message: "Are you sure you want to reject request ?",
            accept: () => {
                this.loading = true;
                this.appServiceManager
                    .post(`requests/${this.requestor[0]._id}/reject`, {})
                    .subscribe(
                        (member) => {
                            this.loading = false;
                            this.messageService.clear();
                            this.messageService.add({
                                severity: "success",
                                summary: "Rejected Message",
                                detail: "Request has been rejected successfully.",
                            });
                            setTimeout(() => {
                                this.router.navigateByUrl(
                                    "/requests-management"
                                );
                            }, 300);
                        },
                        (error) => {
                            this.loading = false;
                            this.messageService.clear();
                            this.messageService.add({
                                severity: "info",
                                summary: "Info Message",
                                detail: "Something went wrong",
                            });
                        }
                    );
            },
        });
    }
}
